export default "/static/bb_shaker_tiny.png";